import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ServerUnavailableOverlay } from "@/components/ServerUnavailableOverlay";
import { API_BASE } from "@/lib/api";
import { BookingFlowPage } from "@/pages/BookingFlowPage";
import { GuestLoginPage } from "@/pages/GuestLoginPage";
import { GuestBookingDetailPage } from "@/pages/GuestBookingDetailPage";
import { GuestPortalPage } from "@/pages/GuestPortalPage";
import { ComfortCheckInPage } from "@/pages/ComfortCheckInPage";
import { PhoneBookingCompletePage } from "@/pages/PhoneBookingCompletePage";
import { detectLocaleFromPath, LocaleProvider } from "@/i18n";
import { InquiryLanguageScope } from "@/lib/bookingLanguage";

function AppRoutes() {
  const { pathname } = useLocation();
  const locale = detectLocaleFromPath(pathname);
  const homePath = locale === "en" ? "/en" : "/";

  return (
    <LocaleProvider locale={locale}>
      <Routes>
        <Route path="/" element={<InquiryLanguageScope><BookingFlowPage /></InquiryLanguageScope>} />
        <Route path="/buchen" element={<InquiryLanguageScope><BookingFlowPage /></InquiryLanguageScope>} />
        <Route path="/en" element={<InquiryLanguageScope><BookingFlowPage /></InquiryLanguageScope>} />
        <Route path="/en/buchen" element={<InquiryLanguageScope><BookingFlowPage /></InquiryLanguageScope>} />
        <Route path="/complete/:token" element={<PhoneBookingCompletePage />} />
        <Route path="/en/complete/:token" element={<PhoneBookingCompletePage />} />
        <Route path="/comfort-check-in/:token" element={<ComfortCheckInPage />} />
        <Route path="/en/comfort-check-in/:token" element={<ComfortCheckInPage />} />
        <Route path="/login" element={<InquiryLanguageScope><GuestLoginPage /></InquiryLanguageScope>} />
        <Route path="/en/login" element={<InquiryLanguageScope><GuestLoginPage /></InquiryLanguageScope>} />
        <Route path="/portal" element={<InquiryLanguageScope><GuestPortalPage /></InquiryLanguageScope>} />
        <Route path="/en/portal" element={<InquiryLanguageScope><GuestPortalPage /></InquiryLanguageScope>} />
        <Route path="/portal/aufenthalt/:bookingId" element={<InquiryLanguageScope><GuestBookingDetailPage /></InquiryLanguageScope>} />
        <Route path="/en/portal/aufenthalt/:bookingId" element={<InquiryLanguageScope><GuestBookingDetailPage /></InquiryLanguageScope>} />
        <Route path="*" element={<Navigate to={homePath} replace />} />
      </Routes>
    </LocaleProvider>
  );
}

function ServerUnavailableGate() {
  const { pathname } = useLocation();
  const locale = detectLocaleFromPath(pathname);
  return <ServerUnavailableOverlay apiBase={API_BASE} locale={locale} />;
}

export function App() {
  return (
    <BrowserRouter>
      <ServerUnavailableGate />
      <AppRoutes />
    </BrowserRouter>
  );
}
